
import { Component, Vue } from 'vue-property-decorator'
import _com from "@/assets/js/common";
@Component
export default class operatModal extends Vue {
    definitionArr = [
        { text: "超清", code: "1080" },
        { text: "高清", code: "720" },
        { text: "标清", code: "480" },
        { text: "流畅", code: "240" }
    ];
    num: any = 0
    tabIndex = 0;
    definition: number = 1
    browser = _com.browser();
    get clearScreen() {
        return this.$store.getters["environment/getClearScreen"];
    }

    get messageClose() {
        return this.$store.getters["environment/getMessageClose"];
    }

    get streamCode() {
        return this.$store.getters["getRoomDetail/getStatus"].tvDefinition;
    }

    get selectStreamCode() {
        return this.$store.getters["environment/getSelectStreamCode"];
    }
    get roomDetail() {
        return this.$store.getters["getRoomDetail/getRoomDetail"];
    }
    get isElderlyMode (){
        return this.$store.getters["environment/getElderlyMode"];
    }
    get isDefinition() {
        let data = this.$store.getters["getRoomDetail/getStatus"]
        if (data.roomStatus == "1" && data.tvStatus == 1)
            return true;
        else {
            this.tabIndex = this.tabIndex == 0 ? 1 : this.tabIndex;
            return false;
        }

    }


    clear() {
        // this.step(1);
        let bool = !this.clearScreen;
        this.$store.dispatch('environment/getClearScreenAsync', bool)
    }

    close() {//关闭/开启弹幕
        if (!this.clearScreen) {
            let bool = !this.messageClose;
            this.$store.dispatch('environment/getMessageCloseAsync', bool)
        }
    }
    report() {//直播举报
        this.$emit('isReport', true)
    }
    changeMode() { //直播切换模式
        let bool:any = !this.isElderlyMode
        this.$store.dispatch('environment/getElderlyModeAsync', bool)
        localStorage.setItem('isElderlyMode',bool)
    }

    chooseDefintion(code: string) {
        this.$store.dispatch('environment/getSelectStreamCodeAsync', code)
    }
    lockHref() {
        this.num++
        if (this.num == 5) {
            alert(location.href)
            this.num = 0
        }
    }
    step() {
        // this.tabIndex = val;
        this.definition = this.definition == 1 ? 0 : 1
        this.$emit('definition', this.definition)
    }

    stop(e: any) {
        e.stopPropagation();
    }
}
